import { createFileRoute } from "@tanstack/react-router";

import PlanSettingsPage from "./-components/PlanSettingsPage";

export const Route = createFileRoute("/_app/_dashboard/$planId/settings")({
  component: PlanSettingsPage,
});
